import type { ObjectKeys } from '../interfaces/ObjectKeys'
import { facetsProducts } from './productFacets'

// Order determines order in sidebar
export const facetsBaseModel: ObjectKeys = {
  ...facetsProducts,
  dial_sizes: {
    label: 'Dial Size'
  },
  gauge_connections: {
    label: 'Gauge Connections'
  },
  accuracies: {
    label: 'Accuracies'
  },
  actuator_seals: {
    label: 'Actuator Seals'
  },
  bore_size: {
    label: 'Bore Size'
  },
  bottom_housing_materials: {
    label: 'Bottom Housing Materials'
  },
  lagging: {
    label: 'Lagging'
  },
  case_materials: {
    label: 'Case Materials'
  },
  connections: {
    label: 'Connections'
  },
  diaphragm_materials: {
    label: 'Diaphragm Materials'
  },
  digital: {
    label: 'Digital'
  },
  electrical_connections: {
    label: 'Electrical Connections'
  },
  enclosures: {
    label: 'Enclosures'
  },
  flange_facing: {
    label: 'Flange Facing'
  },
  flange_classes: {
    label: 'Flange Classes'
  },
  housing: {
    label: 'Housing'
  },
  instrument_connections: {
    label: 'Instrument Connections'
  },
  liquid_fillable: {
    label: 'Liquid Fillable',
    type: 'bool'
  },
  materials: {
    label: 'Materials'
  },
  measurement_type: {
    label: 'Measurement Type'
  },
  poles_throws: {
    label: 'Poles Throws'
  },
  process_connections: {
    label: 'Process Connections'
  },
  pressure_ranges: {
    label: 'Pressure Ranges'
  },
  output_signal: {
    label: 'Output Signal'
  },
  ranges: {
    label: 'Ranges'
  },
  range_pressure_groups: {
    label: 'Range Pressure Groups'
  },
  setpoints: {
    label: 'Setpoints'
  },
  scale_types: {
    label: 'Scale Types'
  },
  stem_lengths: {
    label: 'Stem Lengths'
  },
  switch_elements: {
    label: 'Switch Elements'
  },
  rating_class: {
    label: 'Rating Class'
  },
  temperature_limits: {
    label: 'Temperature Limits'
  },
  upper_housing_materials: {
    label: 'Upper Housing Materials'
  },
  wetted_materials: {
    label: 'Wetted Materials'
  },
  windows: {
    label: 'Windows'
  }
}

export const facetKeysBaseModel = Object.keys(facetsBaseModel)
